import Index from "../../components/Index";

export default Index
